const Arrow = ({color}) => {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.00001 7.00001C5.74401 7.00001 5.48801 6.90201 5.29301 6.70701L0.293006 1.70701C-0.0979941 1.31601 -0.0979941 0.684006 0.293006 0.293006C0.684006 -0.0979941 1.31601 -0.0979941 1.70701 0.293006L6.00001 4.58601L10.293 0.293006C10.684 -0.0979941 11.316 -0.0979941 11.707 0.293006C12.098 0.684006 12.098 1.31601 11.707 1.70701L6.70701 6.70701C6.51201 6.90201 6.25601 7.00001 6.00001 7.00001Z" fill={color}/>
    </svg>
  );
};

export default Arrow;